module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/paper_desktop-f8fd3b426e6e359e9f5c7b48918bed56.png";